module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "memberL"
  }, [_c('pops', {
    attrs: {
      "show": _vm.pop,
      "title": '选择开放范围',
      "width": '800px'
    },
    on: {
      "closePop": _vm.closePop
    }
  }, [_c('div', {
    staticClass: "popScore"
  }, [_c('div', {
    staticClass: "popContent"
  }, [_c('div', {
    staticClass: "leftCont leftScope"
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm._handleClick
    },
    model: {
      value: (_vm.activeType),
      callback: function($$v) {
        _vm.activeType = $$v
      },
      expression: "activeType"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "常用组",
      "name": "first"
    }
  }, [_c('div', {
    staticClass: "rSearch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.groupName),
      expression: "groupName"
    }],
    staticClass: "_input",
    attrs: {
      "placeholder": "请输入常用组名称搜索",
      "type": "text"
    },
    domProps: {
      "value": (_vm.groupName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getGroup($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.groupName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "point el-icon-search",
    on: {
      "click": _vm.getGroup
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "listShow"
  }, _vm._l((_vm.usualGroups), function(group, index) {
    return _c('div', {
      staticClass: "check-group",
      class: {
        'highColor': index === _vm.t
      },
      on: {
        "click": function($event) {
          return _vm.addClass(index)
        }
      }
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.getPeople(group, index)
        }
      }
    }, [_vm._v(_vm._s(group.groupName) + "  ( " + _vm._s(group.total) + " )")]), _vm._v(" "), _c('a', {
      staticClass: "check-group-a",
      on: {
        "click": function($event) {
          return _vm.handleGroup(group)
        }
      }
    }, [_vm._v("添加")])])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "peoples"
  }, _vm._l((_vm.peoples), function(people) {
    return _c('div', {
      staticClass: "check-people",
      on: {
        "click": function($event) {
          return _vm.handleCheckUser(people)
        }
      }
    }, [_c('b', {
      ref: "tName",
      refInFor: true,
      staticClass: "tName",
      attrs: {
        "value": people.id
      }
    }, [_vm._v(_vm._s(people.name))]), _vm._v(" "), (people.attebdType == 0 && people.job != null || people.attebdType == 1 && people.job != null) ? _c('em', {
      ref: "tEm",
      refInFor: true
    }, [_vm._v("（" + _vm._s(people.job) + "）")]) : _vm._e()])
  }), 0)]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "本院",
      "name": "second"
    }
  }, [_c('div', {
    staticClass: "rSearch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deptName),
      expression: "deptName"
    }],
    staticClass: "_input",
    attrs: {
      "placeholder": "请输入本院科室名称搜索",
      "type": "text"
    },
    domProps: {
      "value": (_vm.deptName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getOwnDept($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deptName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "point el-icon-search",
    on: {
      "click": _vm.getOwnDept
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "listShow",
    staticStyle: {
      "text-indent": "10px"
    }
  }, [(_vm.OwnHos) ? _c('div', {
    staticClass: "check-group ownHos"
  }, [_c('span', {
    on: {
      "click": _vm.clickOwnHos
    }
  }, [_vm._v(_vm._s(_vm.OwnhospitalName))]), _vm._v(" "), _c('a', {
    staticClass: "check-group-a",
    on: {
      "click": _vm.handleOwnHos
    }
  }, [_vm._v("添加")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.ownDepts), function(dept, index) {
    return _c('div', {
      staticClass: "check-group",
      class: {
        'highColor': index === _vm.t
      },
      on: {
        "click": function($event) {
          return _vm.addClass(index)
        }
      }
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.getOwnDeptPeople(dept, index)
        }
      }
    }, [_vm._v(_vm._s(dept.deptName) + "  ( " + _vm._s(dept.total) + " )")]), _vm._v(" "), _c('a', {
      staticClass: "check-group-a",
      on: {
        "click": function($event) {
          return _vm.handleOwnDept(dept)
        }
      }
    }, [_vm._v("添加")])])
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "peoples"
  }, _vm._l((_vm.ownDocs), function(doctors) {
    return _c('div', {
      staticClass: "check-people",
      on: {
        "click": function($event) {
          return _vm.handleDeptPeo(doctors)
        }
      }
    }, [_vm._v("\n                 " + _vm._s(doctors.name) + " "), (doctors.job != null) ? _c('em', [_vm._v("（" + _vm._s(doctors.job) + "）")]) : _vm._e()])
  }), 0)]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "按医院",
      "name": "third"
    }
  }, [_c('div', {
    staticClass: "rSearch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hospitalName),
      expression: "hospitalName"
    }],
    staticClass: "_input",
    attrs: {
      "placeholder": "请输入医院名称搜索",
      "type": "text"
    },
    domProps: {
      "value": (_vm.hospitalName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getHosp($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.hospitalName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "point el-icon-search",
    on: {
      "click": _vm.getHosp
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "listShow",
    staticStyle: {
      "height": "391px"
    }
  }, [_vm._l((_vm.allHospital), function(hsp, index) {
    return _c('div', {
      staticClass: "check-group"
    }, [_c('span', [_vm._v(_vm._s(hsp.hosName))]), _vm._v(" "), _c('a', {
      staticClass: "check-group-a",
      on: {
        "click": function($event) {
          return _vm.handleHospital(hsp, index)
        }
      }
    }, [_vm._v("添加")])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nodata),
      expression: "nodata"
    }],
    staticClass: "nodata"
  }, [_vm._v("暂无数据")])], 2)]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "按科室",
      "name": "fouth"
    }
  }, [_c('div', {
    staticClass: "rSearch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deptsName),
      expression: "deptsName"
    }],
    staticClass: "_input",
    attrs: {
      "placeholder": "请输入科室名称搜索",
      "type": "text"
    },
    domProps: {
      "value": (_vm.deptsName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getDept($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deptsName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "point el-icon-search",
    on: {
      "click": _vm.getDept
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "listShow"
  }, [_c('el-tree', {
    ref: "tree",
    staticClass: "check-tree",
    attrs: {
      "data": _vm.data3,
      "node-key": "id",
      "default-expand-all": "",
      "default-expanded-keys": _vm.parKeyId,
      "props": _vm.defaultProps,
      "expand-on-click-node": false
    },
    on: {
      "node-click": _vm.getDeptDocs
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var node = ref.node;
        var data = ref.data;

        return _c('span', {
          staticClass: "custom-tree-node"
        }, [_c('span', [_vm._v(_vm._s(node.label))]), _vm._v(" "), (_vm.nodeShow) ? _c('a', {
          staticClass: "check-tree-a",
          on: {
            "click": function($event) {
              return _vm.handleDept(data)
            }
          }
        }, [_vm._v("添加")]) : _vm._e()])
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "peoples"
  }, _vm._l((_vm.otherDocs), function(doctor) {
    return _c('div', {
      staticClass: "check-people",
      on: {
        "click": function($event) {
          return _vm.handleDeptPeo(doctor)
        }
      }
    }, [_vm._v("\n                 " + _vm._s(doctor.name) + " "), (doctor.job != null) ? _c('em', [_vm._v("（" + _vm._s(doctor.job) + "）")]) : _vm._e()])
  }), 0)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "rightCont"
  }, [_c('div', {
    staticClass: "rightTitle"
  }, [_c('span', {
    staticClass: "alreadyChoose"
  }, [_vm._v("已选择:")]), _vm._v(" "), _c('span', {
    staticClass: "saveAs",
    on: {
      "click": _vm._saveData
    }
  }, [_vm._v("保存为常用组")])]), _vm._v(" "), _c('div', {
    staticClass: "borderCont"
  }, [_c('ul', {
    staticClass: "rtHeight overtHeight"
  }, _vm._l((_vm.checkedList), function(item, index) {
    return _c('li', {
      staticClass: "rightList",
      class: {
        '': item.txtColor == 0, 'txt-yellow': item.txtColor == 3, 'txt-navy': item.txtColor == 2, 'txt-green': item.txtColor == 1
      },
      attrs: {
        "value": item.id,
        "label": item.name,
        "type": item.attebdType
      }
    }, [_c('span', [_vm._v(_vm._s(item.name))]), (item.attebdType == 0 && item.job != null || item.attebdType == 1 && item.job != null) ? _c('em', [_vm._v(_vm._s(item.job))]) : _vm._e(), _vm._v(" "), _c('i', {
      staticClass: "closeBtn",
      on: {
        "click": function($event) {
          return _vm._closeBtn(index)
        }
      }
    }, [_vm._v("删除")])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-box"
  }, [_c('el-button', {
    staticClass: "save",
    on: {
      "click": _vm._saveDepert
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    staticClass: "cancel",
    on: {
      "click": _vm._cancelHos
    }
  }, [_vm._v("取消")])], 1)])]), _vm._v(" "), _c('pops', {
    attrs: {
      "show": _vm.popSaveData,
      "title": '保存常用组',
      "width": '50%'
    },
    on: {
      "closePop": _vm.closeSaveData
    }
  }, [_c('div', {
    staticClass: "popScore"
  }, [_c('el-form', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "span": 10,
      "label": "名称  :",
      "prop": "CurseName"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 10,
      "placeholder": "请输入名称"
    },
    model: {
      value: (_vm.GroupName),
      callback: function($$v) {
        _vm.GroupName = $$v
      },
      expression: "GroupName"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "saveMember"
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "span": 10,
      "label": "组员  :"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "memberTrue",
    model: {
      value: (_vm.groupMembers),
      callback: function($$v) {
        _vm.groupMembers = $$v
      },
      expression: "groupMembers"
    }
  }, [_vm._v(_vm._s(_vm.member))])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-box"
  }, [_c('el-button', {
    staticClass: "save commonBtn",
    on: {
      "click": function($event) {
        return _vm._saveCourseName(_vm.groupMembers)
      }
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    staticClass: "cancel commonBtn",
    on: {
      "click": _vm._cancelGroup
    }
  }, [_vm._v("取消")])], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-3807e77a","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/pops/openFlagPop.vue
// module id = 553
// module chunks = 1 2 3 4 5 6 7 8